// OurLocation.js
import React, { useState, useEffect } from 'react'; // Import useEffect jika Anda perlu memanipulasi URL iframe secara dinamis
import './OurLocation.css';
// Tidak perlu lagi mengimpor customPinIcon karena iframe tidak mendukung marker kustom secara langsung seperti JS API
// import customPinIcon from '../assets/icon/pin_google.png'; 
import SEO from '../SEO/SEO';

const OurLocation = () => {
  // Lokasi toko dengan koordinat. Untuk iframe, alamat lebih disarankan untuk keakuratannya.
  const locations = [
    {
      name: 'Bandung',
      lat: -6.948928, // Contoh latitude Bandung
      lng: 107.706778, // Contoh longitude Bandung
      address: 'Jl. Cimincrang Jl. Kav. Pos Giro No.10, Cimenerang, Kec. Gedebage, Kota Bandung, Jawa Barat 40295',
      // Anda bisa menambahkan info lain di sini
      // Tambahkan properti 'summary' di sini
      summary: 'Pusat layanan utama kami di kota Bandung, Jawa Barat. Siap melayani kebutuhan Anda.'
    }
    /** 
    {
      name: 'Example more',
      lat: 56.8389, // Contoh latitude Yekaterinburg
      lng: 60.6057, // Contoh longitude Yekaterinburg
      address: 'Street adress',
    }
      */
  ];

  const [activeLocation, setActiveLocation] = useState(locations[0]); // State untuk lokasi aktif

  // Fungsi untuk menghasilkan URL iframe Google Maps
  useEffect(() => {
    if (activeLocation) {
      const iframeData = document.getElementById("iframeId");
      // Perbaikan URL untuk iframe: Menggunakan parameter 'q' untuk lokasi dan 'z' untuk zoom
      // Format URL yang lebih umum untuk embed atau tampilan koordinat
      iframeData.src = `https://maps.google.com/maps?q=${activeLocation.lat},${activeLocation.lng}&z=16&output=embed`;
    }
  }, [activeLocation]);

  // Fungsi untuk membuka Google Maps di tab baru dengan pin
  const openGoogleMaps = (latitude, longitude, name) => {
    // Perbaikan URL untuk membuka Google Maps di tab baru:
    // Menggunakan /search/?api=1&query= untuk memastikan pin muncul
    // Menambahkan nama lokasi di query agar lebih jelas di Google Maps
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}&query_place=${name}`;
    window.open(mapUrl, '_blank'); // Membuka di tab baru
  };

  const scrollToContactUs = () => {
    const contactSection = document.getElementById('contact-us');

    if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
    } else {
        window.location.href = '/contact-us';
    }
};

  return (
    <div className="our-location-section">

      <SEO
        title="Rekanata Konstruksi - Lokasi Kami"
        description="Rekanata Konstruksi: jasa kontraktor profesional & terpercaya, melayani pembangunan dan renovasi rumah, kantor, ruko, masjid, bangunan komersial, serta desain interior & lanskap di seluruh Indonesia. Kualitas terjamin dengan layanan terbaik untuk berbagai wilayah di nusantara."
        canonical="https://rekanata.com/our-location"
      />

      <div className="our-location-content">
        <div className="map-container">
          {/* Iframe untuk menampilkan peta Google Maps */}
          <iframe id="iframeId" className="maps"></iframe>
        </div>

        <div className="location-details-wrapper">
          <h1 className="section-title">Lokasi Kami</h1>

          <div className="store-info-group">
            <div className="store-list">
              {locations.map((loc, index) => (
                <div
                  key={index}
                  className={`store-item ${activeLocation.name === loc.name ? 'active' : ''}`}
                  onClick={() => {
                    setActiveLocation(loc); // Mengubah lokasi aktif di UI
                    // Memanggil fungsi openGoogleMaps dengan lat, lng, dan nama lokasi
                    openGoogleMaps(loc.lat, loc.lng, loc.name);
                  }}
                >
                  {loc.name}
                  {loc.summary && (
                    <p className="location-summary">
                      {loc.summary}
                    </p>
                  )}
                </div>
              ))}
            </div>

            <div className="working-hours">
              <h3 className="hours-title">Jam Kerja:</h3>
              <p>Senin-Sabtu: 08:00-17:00</p>
              <p>Hari Minggu kami libur. Jika diperlukan, layanan di hari Minggu hanya tersedia melalui perjanjian yang telah dikonfirmasi sebelumnya.</p>
            </div>
          </div>
        </div>
      </div>

      <footer className="our-location-footer">
        <div className="footer-item">
          <h3 className="footer-title">Phone:</h3>
          <p>+(62) 821 1000 2640</p>
        </div>
        <div className="footer-item address-item">
          <h3 className="footer-title">Address:</h3>
          <p>{activeLocation.address}</p> {/* Mengambil alamat dari lokasi aktif */}
        </div>
        <div className="footer-item">
          <h3 className="footer-title">E-mail:</h3>
          <p>rekanata.contractors@gmail.com</p>
        </div>
        <div className="footer-item live-chat-button-wrapper">
          <button className="live-chat-button" onClick={scrollToContactUs}>
            Hubungi kami
          </button>
        </div>
      </footer>
    </div>
  );
};

export default OurLocation;